import { render, staticRenderFns } from "./ManageProduct.vue?vue&type=template&id=4acc1bf8&scoped=true"
import script from "./ManageProduct.vue?vue&type=script&lang=js"
export * from "./ManageProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acc1bf8",
  null
  
)

export default component.exports